function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Access"
}, React.createElement("rect", {
  x: 8,
  y: 16,
  width: 16,
  height: 9,
  rx: 1,
  ry: 1,
  fill: "none"
}), React.createElement("path", {
  fill: "none",
  d: "M20 11a4 4 0 0 0-4.39-4A4.12 4.12 0 0 0 12 11.17V14h8z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M12 14v-2.83A4.12 4.12 0 0 1 15.61 7a4 4 0 0 1 4.31 3.17 1 1 0 0 0 1 .81 1 1 0 0 0 1-1.16A6 6 0 0 0 15.82 5 6.17 6.17 0 0 0 10 11.25V14H9a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3zm12 10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z"
}));

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("title", null, title), _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHRpdGxlPlRlYW0gUHJvamVjdCBCYXNlZCBBY2Nlc3M8L3RpdGxlPgogIDxnIGlkPSJiNTA0NTVlZC03MDk2LTQ0MDEtYmVlNy05MWUxMzAwODEyZjQiIGRhdGEtbmFtZT0iQWNjZXNzIj4KICAgIDxnPgogICAgICA8cmVjdCB4PSI4IiB5PSIxNiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjkiIHJ4PSIxIiByeT0iMSIgc3R5bGU9ImZpbGw6IG5vbmUiLz4KICAgICAgPHBhdGggZmlsbD0nd2hpdGUnIGQ9Ik0yMCwxMWE0LDQsMCwwLDAtNC4zOS00QTQuMTIsNC4xMiwwLDAsMCwxMiwxMS4xN1YxNGg4WiIgc3R5bGU9ImZpbGw6IG5vbmUiLz4KICAgICAgPHBhdGggZmlsbD0nd2hpdGUnIGQ9Ik0xMiwxNFYxMS4xN0E0LjEyLDQuMTIsMCwwLDEsMTUuNjEsN2E0LDQsMCwwLDEsNC4zMSwzLjE3LDEsMSwwLDAsMCwxLC44MWgwYTEsMSwwLDAsMCwxLTEuMTZBNiw2LDAsMCwwLDE1LjgyLDUsNi4xNyw2LjE3LDAsMCwwLDEwLDExLjI1VjE0SDlhMywzLDAsMCwwLTMsM3Y3YTMsMywwLDAsMCwzLDNIMjNhMywzLDAsMCwwLDMtM1YxN2EzLDMsMCwwLDAtMy0zWk0yNCwyNGExLDEsMCwwLDEtMSwxSDlhMSwxLDAsMCwxLTEtMVYxN2ExLDEsMCwwLDEsMS0xSDIzYTEsMSwwLDAsMSwxLDFaIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { SvgComponent as ReactComponent };